import './Brands.css';
import brandHeader from '../../assets/images/brandHeader.png'
import brands from '../../assets/constants/brands'
import {Link} from 'react-router-dom'
import React from "react";
import Footer from '../Footer';

function Brands(props) {

    return (
        <div className="brands">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <h1 className="brandHeaderText"> Brand </h1>
            <img className="brandHeader" src={brandHeader} alt="work by cerasus, with two purple shimmering butterflies" />
            <p className="brandIntroParagraph"> When we build a brand, we work to create an authentic, aesthetic, and cohesive presence. We focus on the people, both the brand founders and the end users, to ensure that everyone can feel the story behind the work.</p>
            <div className="brandsListDiv">
            {brands.map((brand, index) => (
                <div className="brandRectangleDiv">
                    <img src={brand.src} alt={brand.alt} className="brandRectangle" />
                </div>
            ))}
            </div>
            <Footer/>
        </div>

    )

}

export default Brands;